import type { SegmentedControlOptionType, SegmentedControlProps } from './SegmentedControl';

export interface OldSegmentedControlOptionType extends Omit<SegmentedControlOptionType, 'leftIcon'> {
  /** @deprecated leftIcon을 대신 사용해주세요. */
  icon?: SegmentedControlOptionType['leftIcon'];
}

export type OldSegmentedControlProps = Omit<SegmentedControlProps, 'items' | 'keyExtractor'> & {
  items: OldSegmentedControlOptionType[];
  keyExtractor?: (item: OldSegmentedControlOptionType, index: number) => string | number;
};

function convertOldSegmentedControlOption(item: OldSegmentedControlOptionType): SegmentedControlOptionType {
  const { icon, ...restItem } = item;

  return {
    ...restItem,
    leftIcon: icon,
  };
}

export function convertOldSegmentedControlProps(props: OldSegmentedControlProps): SegmentedControlProps {
  const { items, keyExtractor, ...restProps } = props;

  return {
    ...restProps,
    items: items.map(convertOldSegmentedControlOption),
    keyExtractor: keyExtractor
      ? (item, index) => {
          const { leftIcon, ...restItem } = item;
          return keyExtractor({ ...restItem, icon: leftIcon }, index);
        }
      : undefined,
  };
}
